import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "42.138",
  viewBox: "0 0 42.138 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M14.842-.07L0 14.77l14.842 14.906 3.145-3.145-9.497-9.494h32.955V12.63H8.363l9.562-9.56-3.083-3.14zm12.452 20.25l-3.144 3.082 9.498 9.497H.692v4.4h33.08l-9.558 9.62 3.08 3.145L42.138 35.02 27.294 20.18z"
  })]
});